import RelativeWorkingInCourt, {
  IRelativeWorkingInCourt
} from "../../../model/report/applicantdata/RelativeWorkingInCourt";
import AdditionalIncome, {
  IAdditionalIncome
} from "../../../model/report/applicantdata/AdditionalIncome";
import NonPaidActivity, {
  INonPaidActivity
} from "../../../model/report/applicantdata/NonPaidActivity";
import GiftAndDonation, {
  IGiftAndDonation
} from "../../../model/report/applicantdata/GiftAndDonation";
import DebtObligation, {
  IDebtObligation
} from "../../../model/report/applicantdata/DebtObligation";
import Report8Applicant, {
  IReport8Applicant
} from "../../../model/report/Report8Applicant";

const ApplicantsMapper = (json = []) => {
  return json.map((item: any) => {
    let applicants = Report8Applicant(item);
    return applicants;
  });
};

const RelativesMapper = (json = []) => {
  return json.map((item: any) => {
    let relatives = RelativeWorkingInCourt(item);
    return relatives;
  });
};

const AdditionalIncomeMapper = (json = []) => {
  return json.map((item: any) => {
    let additionalIncome = AdditionalIncome(item);
    return additionalIncome;
  });
};

const NonPaidActivityMapper = (json = []) => {
  return json.map((item: any) => {
    let nonPaidActivities = NonPaidActivity(item);
    return nonPaidActivities;
  });
};

const GiftsMapper = (json = []) => {
  return json.map((item: any) => {
    return GiftAndDonation(item);
  });
};

const DebtMapper = (json = []) => {
  return json.map((item: any) => {
    return DebtObligation(item);
  });
};
function findAdditionalIncome(
  additionalIncome: IAdditionalIncome[],
  applicant: IReport8Applicant
) {
  return additionalIncome.filter(
    (income: IAdditionalIncome) => income.applicantId === applicant.id
  );
}
function findNonPaidActivity(
  nonPaidActivities: INonPaidActivity[],
  applicant: IReport8Applicant
) {
  return nonPaidActivities.filter(
    (activity: INonPaidActivity) => activity.applicantId === applicant.id
  );
}
function findRelativeWorkingInCourt(
  relatives: IRelativeWorkingInCourt[],
  applicant: IReport8Applicant
) {
  return relatives.filter(
    (relative: IRelativeWorkingInCourt) => relative.applicantId === applicant.id
  );
}
function findGiftAndDonation(
  giftsAndDonations: IGiftAndDonation[],
  applicant: IReport8Applicant
) {
  return giftsAndDonations.filter(
    (gift: IGiftAndDonation) => gift.applicantId === applicant.id
  );
}
function findDebtObligation(
  debtObligations: IDebtObligation[],
  applicant: IReport8Applicant
) {
  return debtObligations.filter(
    (debtObligation: IDebtObligation) =>
      debtObligation.applicantId === applicant.id
  );
}
function groupElements(
  applicants: IReport8Applicant[],
  relatives: IRelativeWorkingInCourt[],
  additionalIncome: IAdditionalIncome[],
  nonPaidActivities: INonPaidActivity[],
  gifts: IGiftAndDonation[],
  debt: IDebtObligation[]
) {
  let applicantDetails = applicants.map((applicant: IReport8Applicant) => {
    applicant.relativesWorkingInCourt = findRelativeWorkingInCourt(
      relatives,
      applicant
    );
    applicant.additionalIncome = findAdditionalIncome(
      additionalIncome,
      applicant
    );
    applicant.nonPaidActivities = findNonPaidActivity(
      nonPaidActivities,
      applicant
    );
    applicant.giftsAndDonations = findGiftAndDonation(gifts, applicant);
    applicant.debtObligations = findDebtObligation(debt, applicant);
    return applicant;
  });
  return applicantDetails;
}

const Report8DataMapper = async (
  applicants: any,
  relatives: any,
  additionalIncome: any,
  nonPaidActivities: any,
  gifts: any,
  debt: any
) => {
  let applicantMappedList = ApplicantsMapper(applicants);
  let relativesMappedList = RelativesMapper(relatives);
  let additionalIncomeMappedList = AdditionalIncomeMapper(additionalIncome);
  let nonPaidActivitiesMappedList = NonPaidActivityMapper(nonPaidActivities);
  let giftsMappedList = GiftsMapper(gifts);
  let debtMappedList = DebtMapper(debt);

  const applicantDetailsList = groupElements(
    applicantMappedList,
    relativesMappedList,
    additionalIncomeMappedList,
    nonPaidActivitiesMappedList,
    giftsMappedList,
    debtMappedList
  );
  return applicantDetailsList;
};

export default Report8DataMapper;
